// third-party
import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project import
import calendar from './calendar';
import menu from './menu';
import snackbar from './snackbar';
import cartReducer from './cart';
import chat from './chat';
import productReducer from './product';
import kanban from './kanban';
import invoice from './invoice';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
    calendar,
    chat,
    menu,
    snackbar,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'dfnt-'
        },
        cartReducer
    ),
    product: productReducer,
    kanban,
    invoice
});

export default reducers;
